/* Infinite-loop hero carousel on phones.

   On phones the hero is not a Flickity carousel — .shoppable-blog__slider is a
   plain overflow-x scroller with CSS scroll-snap. It has a start and an end, so
   banner 1 sat against empty space on the left and the last banner ran out on
   the right.

   This makes the ends meet, the usual clone trick:

     [copy of banner N] [banner 1] [banner 2] ... [banner N] [copy of banner 1]

   The scroller opens on banner 1 with the copy of banner N peeking at the left
   edge and banner 2 peeking at the right. Scroll onto either copy and the
   scroll position jumps silently by one full set, landing on the real banner
   that looks identical — so it can be scrolled either way forever without
   hitting an end.

   The jump has to be instant. The track carries scroll-behavior: smooth, which
   would animate the correction and make the seam obvious, so it is switched off
   for the moment of the jump and restored straight after.

   Desktop is untouched: it uses Flickity, and this bails out when Flickity is
   present or the viewport is above the phone breakpoint. */
(function () {
  var SECTION = '[id$="__section_slide_by_slide_Y4TV3f"]';
  var PHONE = '(max-width: 749px)';
  var SETTLE_MS = 120;

  /* Clones inherit the lazy-loader's classes but not its resolved src, so the
     copies would stay blank. Point them at whatever the original resolved to. */
  function copyLoadedImages(from, to) {
    var a = from.querySelectorAll('img');
    var b = to.querySelectorAll('img');
    for (var i = 0; i < a.length && i < b.length; i++) {
      var src = a[i].currentSrc || a[i].src || a[i].getAttribute('data-src');
      if (src) {
        b[i].src = src;
        b[i].removeAttribute('data-src');
        b[i].classList.remove('lazyload');
        b[i].classList.add('lazyloaded');
      }
      var bg = a[i].getAttribute('data-bgset');
      if (bg) b[i].removeAttribute('data-bgset');
    }
    // Background-image cells (the theme paints some banners that way).
    var fa = from.querySelectorAll('[style*="background-image"]');
    var fb = to.querySelectorAll('[style*="background-image"]');
    for (var j = 0; j < fa.length && j < fb.length; j++) {
      fb[j].style.backgroundImage = fa[j].style.backgroundImage;
      fb[j].classList.remove('lazyload');
    }
  }

  function setup(hero) {
    var track = hero.querySelector('.shoppable-blog__slider');
    if (!track || track.getAttribute('data-dd-loop')) return;

    var cells = [].slice.call(track.querySelectorAll('.blog-item'));
    if (cells.length < 2) return;
    track.setAttribute('data-dd-loop', '1');

    /* Counted live rather than captured once. These banners carry
       .geo-us-banner and the theme drops some of them after load depending on
       the visitor's country, so a number taken at setup goes stale and every
       wrap lands one banner out. */
    function realCount() {
      return track.querySelectorAll('.blog-item:not([data-dd-clone])').length;
    }

    var head = cells[cells.length - 1].cloneNode(true); // copy of the last banner
    var tail = cells[0].cloneNode(true);                // copy of the first
    head.setAttribute('data-dd-clone', 'last');
    tail.setAttribute('data-dd-clone', 'first');
    copyLoadedImages(cells[cells.length - 1], head);
    copyLoadedImages(cells[0], tail);
    track.insertBefore(head, cells[0]);
    track.appendChild(tail);

    function pitch() {
      var all = track.querySelectorAll('.blog-item');
      if (all.length > 1) {
        var d = all[1].offsetLeft - all[0].offsetLeft;
        if (d > 0) return d;
      }
      return all[0] ? all[0].offsetWidth : 0;
    }

    function jumpTo(px) {
      var previous = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = px;
      void track.offsetWidth; // flush before restoring, so nothing animates
      track.style.scrollBehavior = previous || '';
    }

    // Open on banner 1, which now sits one slot in behind the leading copy.
    jumpTo(pitch());

    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var p = pitch();
        if (!p) return;
        var set = realCount() * p;
        // Landed on the leading copy of the last banner -> hop to the real one.
        if (track.scrollLeft < p * 0.5) jumpTo(track.scrollLeft + set);
        // Landed on the trailing copy of the first -> hop back to the real one.
        else if (track.scrollLeft > set + p * 0.5) jumpTo(track.scrollLeft - set);
      }, SETTLE_MS);
    }, { passive: true });

    /* The theme's own arrows call handleSlideNav, which counts slides, scrolls
       by the container's full width and disables itself at each end — none of
       which suits a loop. Replace them with a one-banner step that never
       disables.

       The step is instant rather than behavior:'smooth'. Smooth scrolling runs
       on requestAnimationFrame, which browsers suspend while a tab is in the
       background, so the arrows would silently do nothing there. Landing on a
       clone is also pointless when the move is instant, so the target is
       normalised onto the equivalent real banner in the same step. */
    function step(direction) {
      var p = pitch();
      if (!p) return;
      var set = realCount() * p;
      var target = track.scrollLeft + direction * p;
      if (target < p * 0.5) target += set;          // stepped onto the copy of the last
      else if (target > set + p * 0.5) target -= set; // stepped onto the copy of the first
      jumpTo(target);
    }

    var arrows = hero.querySelectorAll('.mobile-slide-btn');
    for (var k = 0; k < arrows.length; k++) {
      (function (btn) {
        var back = btn.classList.contains('prev');
        btn.removeAttribute('onclick');
        btn.onclick = null;
        btn.setAttribute('data-disabled', 'false');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          step(back ? -1 : 1);
        });
      })(arrows[k]);
    }
  }

  function start() {
    if (!window.matchMedia || !window.matchMedia(PHONE).matches) return;
    /* The id matches more than one element — the theme keeps a hidden copy of
       the header/section for measuring — so pick the one that actually holds
       the scroller rather than whichever comes first. */
    var heroes = document.querySelectorAll(SECTION);
    for (var i = 0; i < heroes.length; i++) {
      var track = heroes[i].querySelector('.shoppable-blog__slider');
      if (!track) continue;

      /* Whether this is the desktop carousel is decided by what the track is
         actually doing, not by the .flickity-enabled class. That class sticks
         around when the page was first laid out wide and later narrowed — a
         phone opened through device emulation, or a window dragged smaller —
         so testing for it skipped the very case this is meant to handle.
         Flickity builds .flickity-slider and takes the element off native
         scrolling; a phone track has neither. */
      if (track.querySelector('.flickity-slider')) continue;
      var overflow = getComputedStyle(track).overflowX;
      if (overflow !== 'auto' && overflow !== 'scroll') continue;

      setup(heroes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // The banners are lazy-loaded, so widths settle a beat after load.
  setTimeout(start, 800);
  setTimeout(start, 2000);

  /* Also run when the layout crosses into phone width without a reload — a
     window dragged narrower, a device-emulation toolbar, or an orientation
     change. setup() guards itself, so running again is harmless. */
  if (window.matchMedia) {
    var mq = window.matchMedia(PHONE);
    var onChange = function () { setTimeout(start, 150); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
  window.addEventListener('resize', function () {
    clearTimeout(window.ddHeroResizeTimer);
    window.ddHeroResizeTimer = setTimeout(start, 250);
  });
})();
